/**
 * Hash-части вкладок формы редактирования соревнования.
 *
 * Живут в `domain`, а не рядом с формой, потому что hash — часть роута
 * (`Pages.CHAMPIONSHIPS.builders.edit`), а не деталь вёрстки. Подписи вкладок и их
 * порядок — в `ui/components/edit-form/constants.ts`: там они привязаны к типу
 * `Tab` из `ud-ui`, которому в `domain` не место.
 */
export enum ChampionshipEditTab {
  COMMON = 'common',
  RULES = 'rules',
  /** Вкладка называется TEAMS, а показывает заявки команд — см. глоссарий. */
  TEAMS = 'applications',
  STEPS = 'steps',
  SYMBOLIC_TEAMS = 'symbolic-teams',
  MEDIA = 'media',
}
